export { default as WoundPatientService } from './WoundPatientService';
export { default as WoundPatientRouteService } from './WoundPatientRouteService';

